import { Interval } from 'luxon'
import { getJsDate, getFormattedDate } from '@/utils/date'
import { assertExists } from '@/utils/general'

export default {
  computed: {
    numNights() {
      const d = this.dates
      if (!d || !d[1] || d[0] == null || d[1] == null) {
        return 0
      }
      return Math.abs(
        Interval.fromDateTimes(getJsDate(d[0]), getJsDate(d[1])).count('days') -
          1
      )
    },
  },
  methods: {
    getCountryByCode(code) {
      const country = this.countries.find(country => country.code === code)
      return country ? country.label : false
    },

    getFormattedDate(date) {
      if (!date) return
      return getFormattedDate(date, this.$t('generic.date.format'))
    },
  },
  mounted() {
    /** test if variables used in this mixin exist in the context the component **/
    assertExists('countries', this)
    assertExists('dates', this)
  },
}
